import React, {useState, useEffect} from 'react';

const DraggableList = ({value, onChange, itemRenderer, header, footer}) => {

  const [model, setModel] = useState(value || []);
  const [itemRefs, setItemRefs] = useState(model.map(() => React.createRef()));

  const setModelAndRefs = newModel => {
    setModel(newModel);
    setItemRefs(newModel.map(() => React.createRef()));
  }

  const setModelAndNotify = newModel => {
    setModelAndRefs(newModel);
    onChange(newModel);
  }

  useEffect(() => { setModelAndRefs(value || []); }, [ value ]);

  const swap = (fromIndex, toIndex, belowOrAbove) => {
    if (fromIndex === toIndex) {
      return;
    }
    const result = [];
    for (let i = 0 ; i < model.length ; i++) {
      if (i === fromIndex) {
        continue;
      }
      if (i === toIndex && belowOrAbove === 'ABOVE') {
        result.push(model[fromIndex]);
      }
      result.push(model[i]);
      if (i === toIndex && belowOrAbove === 'BELOW') {
        result.push(model[fromIndex]);
      }
    }
    setModelAndNotify(result);
  }

  const tryFindItemBoundingClientRect = index => {
    if (itemRefs.length <= index) {
      return null;
    }
    const element = (itemRefs[index] || {}).current || null;
    if (!element) {
      return null;
    }
    return element.getBoundingClientRect ? element.getBoundingClientRect() : null;
  }

  const tryFindOffsetBetweenMouseAndMiddle = (e, index) => {
    const itemBoundingClientRect = tryFindItemBoundingClientRect(index);
    if (!itemBoundingClientRect) {
      console.log('Custom Forms - WARN - Unable to get underlying DOM element, drag\'n drop won\'t be very intuitive');
      return 0;
    }
    return e.clientY - (itemBoundingClientRect.y + itemBoundingClientRect.height / 2.0);
  }

  const onDragStart = (e, index) => {
    e.dataTransfer.setData('fromIndex', index.toString());
    e.dataTransfer.setData(
      'offsetBetweenMouseAndMiddle',
      tryFindOffsetBetweenMouseAndMiddle(e, index).toFixed(0));
  }

  const onDrop = (e, index) => {
    const fromIndex = parseInt(e.dataTransfer.getData('fromIndex'), 10);
    if (index === fromIndex) {
      return;
    }

    const fromElementOffsetBetweenMouseAndMiddle = parseInt(e.dataTransfer.getData('offsetBetweenMouseAndMiddle'), 10);
    const middleOfFromElementY = e.clientY - fromElementOffsetBetweenMouseAndMiddle;

    const itemBoundingClientRect = tryFindItemBoundingClientRect(index);
    const middleOfToElementY = itemBoundingClientRect ?
      itemBoundingClientRect.y + itemBoundingClientRect.height / 2.0 :
      999999;

    const belowOrAbove = middleOfFromElementY > middleOfToElementY ? 'BELOW' : 'ABOVE';
    swap(fromIndex, index, belowOrAbove);
  }

  return <ul className="list-group">
    {header}
    {model.map((item, i) => {
      return <li key={i} className="list-group-item"
                 ref={itemRefs[i]}
                 draggable="true"
                 onDragOver={e => {
                   e.stopPropagation();
                   e.preventDefault();
                   return false;
                 }}
                 onDragStart={e => onDragStart(e, i)}
                 onDrop={e => onDrop(e, i)}>
        {itemRenderer(item, i)}
      </li>
    })}
    {footer}
  </ul>;

}

export default DraggableList;
